module.exports = "/_next/static/images/01238d8c3e91fc0f98d0f0cabff3eab0-support-icon.svg";